(function () {
  function initScroller(section) {
    var scroller = section.querySelector('.cac-new-scroller');
    var prevBtn = section.querySelector('.cac-new-arrow-prev');
    var nextBtn = section.querySelector('.cac-new-arrow-next');
    var fade = section.querySelector('.cac-new-fade');
    if (!scroller) return;

    function scrollByCard(direction) {
      var card = scroller.querySelector('.cac-new-card');
      var cardWidth = card ? card.getBoundingClientRect().width + 16 : 420;
      scroller.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });
    }

    function updateFade() {
      if (!fade) return;
      var maxScroll = scroller.scrollWidth - scroller.clientWidth;
      var nearEnd = scroller.scrollLeft >= maxScroll - 8;
      var noOverflow = maxScroll <= 4;
      fade.classList.toggle('is-hidden', nearEnd || noOverflow);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });

    scroller.addEventListener('scroll', updateFade, { passive: true });
    window.addEventListener('resize', updateFade);
    updateFade();
  }

  function initAll() {
    document.querySelectorAll('.cac-new-outer').forEach(initScroller);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.cac-new-outer') || e.target;
    if (section) initScroller(section);
  });
})();